import * as Yup from 'yup'
import { MOVEMENT_ACTION } from 'domains/inventory/constants/inventory-constants'

const MANUAL_MOVEMENT_ACTIONS = [
  MOVEMENT_ACTION.MANUALLY_ADD_ITEM,
  MOVEMENT_ACTION.MANUALLY_REMOVE_ITEM
]
Object.freeze(MANUAL_MOVEMENT_ACTIONS)

const inventoryFixQuantityFormSchema = () => (
  Yup.object().shape({
    action: Yup.string()
      .oneOf(Object.values(MANUAL_MOVEMENT_ACTIONS),'invalid action method')
      .required('action required'),
    quantity: Yup.number()
      .positive('number must be positive')
      .required('required'),
    location    : Yup.object().required('Required'),
    description : Yup.string().required('Required')
  })
)

export default inventoryFixQuantityFormSchema